<div>
  <div class="content-info">
    <div class="content-title">
      <h3 class="title">Vendors</h3>
      <div class="title-actions">
        <label class="zf-search" title="Search vendors">
          <i class="bi bi-search"></i>
          <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search vendors" />
        </label>

        <!-- Consolidated Downloads Dropdown -->
        <div class="dropdown d-inline-block">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="downloadsDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-download"></i> Downloads
          </button>
          <ul class="dropdown-menu" aria-labelledby="downloadsDropdown">
            <li><h6 class="dropdown-header">Templates</h6></li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadCreationTemplate()">
                For creation (auto-generated code)
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadUpdateTemplate()">
                For update (with vendor code)
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadMappingTemplate()">
                For vendor–manufacturer mapping
              </a>
            </li>
            <li><hr class="dropdown-divider"></li>
            <li><h6 class="dropdown-header">Data exports</h6></li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="openExportModal(exportConfirmationModal)">
                Export Excel
              </a>
            </li>
          </ul>
        </div>

        <!-- Bulk Upload Dropdown -->
        <div class="dropdown d-inline-block">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="bulkVendorUploadDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-upload"></i> Bulk upload
          </button>
          <ul class="dropdown-menu" aria-labelledby="bulkVendorUploadDropdown">
            <li><a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('CREATE')">Bulk create</a></li>
            <li><a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('UPDATE')">Bulk update</a></li>
            <li><a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('MAPPING')">Bulk mapping upload</a></li>
          </ul>
        </div>

        <!-- Hidden File Input -->
        <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xlsx, .xls" />

        <button class="btn btnprimary text-nowrap" [routerLink]="['/add-vendor']">
          <i class="bi bi-plus-lg"></i> Add vendor
        </button>
      </div>
    </div>

    <div class="common-table">
      <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
        <table class="table">
          <thead>
            <tr>
              <th>Vendor Code</th>
              <th>Name</th>
              <th>Contact Person</th>
              <th>Contact Phone</th>
              <th>City</th>
              <th>GSTIN</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @if(vendorsLoading) {
            <tr>
              <td colspan="8" class="text-center">Loading vendors…</td>
            </tr>
            } @else { @if(!vendors.length) {
            <tr>
              <td colspan="8">
                <div class="zf-empty">
                  <strong>No vendors found</strong>
                  <span>Add a vendor or import them with the bulk upload.</span>
                </div>
              </td>
            </tr>
            } @else { @for(vendor of vendors; track vendor.id) {
            <tr>
              <td class="zf-key">
                <a [routerLink]="['/edit-vendor', vendor.id]">{{ vendor.vendorCode }}</a>
              </td>
              <td class="zf-strong">{{ vendor.name }}</td>
              <td>{{ vendor.contactPerson }}</td>
              <td class="zf-mono zf-dim">{{ vendor.contactPhone }}</td>
              <td>{{ vendor.city }}</td>
              <td class="zf-mono zf-dim">{{ vendor.gstin }}</td>
              <td>
                <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="statusSwitch-{{ vendor.id }}"
                    [checked]="vendor.isActive" (change)="toggleStatus(vendor)" />
                  <label class="form-check-label" [for]="'statusSwitch-' + vendor.id">
                    <span class="zf-status" [class.ok]="vendor.isActive">{{ vendor.isActive ? "Active" : "Inactive" }}</span>
                  </label>
                </div>
              </td>
              <td>
                <div class="td-actions-btn">
                  <button class="btn btn-edit" [routerLink]="['/edit-vendor', vendor.id]" title="Edit vendor">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </div>
              </td>
            </tr>
            } } }
          </tbody>
        </table>
      </div>
      <div class="table-pagination">
        <div class="pagination-count">
          <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
          </select>
          <span>entries per page</span>
        </div>
        <ul class="pagination">
          <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
            <a class="page-link" aria-label="Previous">&lsaquo;</a>
          </li>
          <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
            <a class="page-link">1</a>
          </li>
          @if (currentPage > 4) {
          <li class="page-item disabled"><a class="page-link">…</a></li>
          }
          @for (page of getVisiblePages(); track page) {
          <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
            <a class="page-link">{{ page }}</a>
          </li>
          }
          @if (currentPage < pageCount - 3) {
          <li class="page-item disabled"><a class="page-link">…</a></li>
          }
          @if (pageCount > 1) {
          <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
            <a class="page-link">{{ pageCount }}</a>
          </li>
          }
          <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
            <a class="page-link" aria-label="Next">&rsaquo;</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Delete Modal Template -->
  <ng-template #deleteConfirmationModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title" id="confirmDeleteModalLabel">Confirm delete</h5>
      <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>
    <div class="modal-body delete-msg">
      <h3>Are you sure you want to delete <strong>{{ vendorToDelete?.name }}</strong>?</h3>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btnsecondary" (click)="closeModal()">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
    </div>
  </ng-template>

  <!-- Export Confirmation Modal Template -->
  <ng-template #exportConfirmationModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Export vendors</h5>
      <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <p class="mb-0">Export the vendor master to an Excel workbook?</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btnsecondary" (click)="closeModal()">No</button>
      <button type="button" class="btn btnprimary" (click)="exportToExcel()">
        <i class="bi bi-download"></i>Yes, export
      </button>
    </div>
  </ng-template>
</div>
